import React, { useEffect, useState } from "react";

import { PanelWithHeader } from "../panels/PanelWithHeader";
import { TasksSummary } from "../todo/TasksSummary";
import { BodyWeightChart } from "../lifestyle/BodyWeightChart";
import { QuickLoansStatistics } from "../loans/QuickLoansStatistics";
import { QuickShoppingList } from "../shopping/QuickShoppingList";

import { PanelWithBreadCrumbAndSearchBox } from "../panels/PanelWithBreadCrumbAndSearchBox";
import { apiGetLifeStyle } from "../../services/LifeStyleService";
import { DomikLoading } from "../common/DomikLoading";

type UserHomePageProps = {
  value: string;
};

export const UserHomePage = (props: UserHomePageProps) => {
  const [dataLifeStyle, setDataLifeStyle] = useState({ rows: [{}] });
  const [loadingLifeStyle, setLoadingLifeStyle] = useState(true);

  useEffect(() => {
    apiGetLifeStyle().then((response) => {
      setDataLifeStyle({ rows: response.data });
      setLoadingLifeStyle(false);
    });
  }, []);

  return (
    <div className="container-fluid mt-3">
      <PanelWithBreadCrumbAndSearchBox currentPageName="LifeStyle" />
      {/* <-- ~Heading --> */}

      <div className="row wow fadeIn">
        <div className="col-lg-9 col-md-6 mb-4">
          <PanelWithHeader
            header="LifeStyle / Vývoj váhy"
            iconClassName="fas fa-running"
          >
            {!loadingLifeStyle && (
              <BodyWeightChart weightRows={dataLifeStyle.rows} />
            )}

            {loadingLifeStyle && <DomikLoading />}
          </PanelWithHeader>
        </div>

        <div className="col-lg-3 col-md-6 mb-4">
          <PanelWithHeader header="Seznam úkolů" iconClassName="fas fa-tasks">
            <TasksSummary completed={47} inProgress={6} notStarted={22} />
          </PanelWithHeader>
        </div>

        <div className="col-lg-6 col-md-6 mb-4">
          <PanelWithHeader
            header="Dlužníček"
            iconClassName="fas fa-search-dollar"
          >
            <QuickLoansStatistics />
          </PanelWithHeader>
        </div>

        <div className="col-lg-6 col-md-6 mb-4">
          <PanelWithHeader
            header="Nákupní seznam"
            iconClassName="fas fa-shopping-cart"
          >
            <QuickShoppingList />
          </PanelWithHeader>
        </div>
      </div>
    </div>
  );
};
